import { render, staticRenderFns } from "./update-course-producer.html?vue&type=template&id=95ee7f76&scoped=true&"
import script from "./update-course-producer.js?vue&type=script&lang=js&"
export * from "./update-course-producer.js?vue&type=script&lang=js&"
import style0 from "./update-course-producer.scss?vue&type=style&index=0&id=95ee7f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ee7f76",
  null
  
)

export default component.exports